export default function bookings(state = [], action) {
  switch (action.type) {
    case 'UPDATE_BOOKINGS':
      return action.bookings;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/bookings.js